

import React from 'react';
import { Box, Text } from '../../shared/components';

export default function InlineCard({ headerText, content }) {
  return (
    <Box className="inlineCard">
      <Text
        px={5}
        py={3}
        style={{
          color: '#403F3D',
          fontFamily: 'Open Sans',
          fontSize: '24px',
          letterSpacing: '1.21px',
          lineHeight: '24px',
          marginTop: '7px',
          fontWeight: '600',
          marginBottom: '16px',
        }}
      >
        {headerText}

      </Text>
      <Box p={5} bg="white">
        { content }
      </Box>
    </Box>
  );
}
